import { Component, OnInit, Renderer2, inject } from '@angular/core'
import { AuthService } from './services/auth.service'
import { DataSharedService } from './services/data-shared.service'
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router'
import { DeviceDetectorService } from 'ngx-device-detector'
import {NgbModalConfig, NgbTooltipConfig} from "@ng-bootstrap/ng-bootstrap";
import {OAuthService} from "angular-oauth2-oidc";
import {JwksValidationHandler} from "angular-oauth2-oidc-jwks";
import { AUTH_CONFIG } from './config/auth.config'


@Component({
    selector: 'lg-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private authService = inject(AuthService);
  private dataSharedService = inject(DataSharedService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private renderer = inject(Renderer2);
  deviceService = inject(DeviceDetectorService);

  constructor() {
    const router = this.router;
    const deviceService = this.deviceService;

    ;(window as any).deviceService = deviceService
    ;(window as any).router = router

    const configModal = inject(NgbModalConfig);
    const configTooltip = inject(NgbTooltipConfig);
    const oAuthService = inject(OAuthService);

    configModal.centered = true

    configTooltip.container = 'body'
    configTooltip.openDelay = 600

    oAuthService.configure(AUTH_CONFIG)
    oAuthService.tokenValidationHandler = new JwksValidationHandler()
    oAuthService.setStorage(localStorage)
  }

  ngOnInit(): void {
    this.removeStartupLoader()
    this.addBodyClass()
  }

  removeStartupLoader() {
    const startupLoader: HTMLElement = document.getElementById('startup-loader')
    if (startupLoader) {
      startupLoader.remove()
    }
  }

  addBodyClass() {
    if (this.deviceService.isDesktop()) {
      this.renderer.addClass(document.body, 'desktop')
    } else {
      this.renderer.addClass(document.body, 'mobile-tablet')
    }
  }
}
